/**
 * @generated SignedSource<<c8072e566be2615c9f169051b183f1d7>>
 * @relayHash e3b7fcde55b949bf8d80bddd9a0ac180
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d

import type { ConcreteRequest } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type UserProfileClientForConfluenceQuery$variables = {
  userId?: string | null;
};
export type UserProfileClientForConfluenceQuery$data = {
  readonly entitlements: {
    readonly externalCollaborator: {
      readonly isEntitled: boolean;
    };
  } | null;
  readonly user: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type UserProfileClientForConfluenceQuery = {
  response: UserProfileClientForConfluenceQuery$data;
  variables: UserProfileClientForConfluenceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": false
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "userId"
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "permissionType"
          }
        ]
      }
    ]
  },
  {
    "concreteType": "Entitlements",
    "kind": "LinkedField",
    "name": "entitlements",
    "plural": false,
    "selections": [
      {
        "concreteType": "ExternalCollaboratorFeature",
        "kind": "LinkedField",
        "name": "externalCollaborator",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isEntitled"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "UserProfileClientForConfluenceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserProfileClientForConfluenceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e3b7fcde55b949bf8d80bddd9a0ac180",
    "id": "ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d",
    "metadata": {},
    "name": "UserProfileClientForConfluenceQuery",
    "operationKind": "query",
    "text": "query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false,id:$userId){id,confluence{permissionType}},entitlements{externalCollaborator{isEntitled}}}"
  }
};
})();

(node as any).hash = "f636f7ede64e4c0d1757767b061d53b5";

export default node;
